import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  TypeQualifier1esmq2h0dalsb as TypeQualifier,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  binds4rk2rn2wwzpn as binds,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  getKClass1s3j9wy1cofik as getKClass,
  Unit_instance104q5opgivhr8 as Unit_instance,
  VOID7hggqo3abtya as VOID,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$1s1wkrw82c0iw as ArrayList_init_$Create$,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  LazyThreadSafetyMode_PUBLICATION_getInstance2x9bac6dffafm as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Long2qws0ah9gnpki as Long,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  toString30pk9tzaqopn as toString,
  toString1pkumu07cwy4m as toString_0,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Enum3alwj03lh1n41 as Enum,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Result3t1vadv16kmzk as Result,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  KtList3hktaavzmj137 as KtList,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  _Result___get_value__impl__bjfvqgo6z1uu11rodr as _Result___get_value__impl__bjfvqg,
  _Result___init__impl__xyqfz81wclroc5pw7j2 as _Result___init__impl__xyqfz8,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___get_isSuccess__impl__sndoy82z6txcyihce8z as _Result___get_isSuccess__impl__sndoy8,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  replace3le3ie7l9k8aq as replace,
  createFailure8paxfkfa5dc7 as createFailure,
  CancellationException3b36o9qz53rgr as CancellationException,
  Result__exceptionOrNull_impl_p6xea9boty10p2dkn4 as Result__exceptionOrNull_impl_p6xea9,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  Unitkvevlwgzwiuc as Unit,
  getValue48kllevslyh6 as getValue,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from './kotlin-kotlin-stdlib.mjs';
import {
  CourseAssignment1xjmha07g2pas as CourseAssignment,
  ICourseAssignmentAccessor1kq9psvks8u5i as ICourseAssignmentAccessor,
  ICourseAssignmentMutator2azke9qzwsfw9 as ICourseAssignmentMutator,
  ITrainingReviewRequestAccessor39vjylhpgn8zg as ITrainingReviewRequestAccessor,
  ITrainingTaskSignOffReviewAccessorycsti4iwagpr as ITrainingTaskSignOffReviewAccessor,
  Course38dfyat4grbns as Course,
  CourseAssignmentStatus_NOT_STARTED_getInstance35085ko59qrt3 as CourseAssignmentStatus_NOT_STARTED_getInstance,
  CourseAssignmentStatus_IN_PROGRESS_getInstancek678yld7zzw6 as CourseAssignmentStatus_IN_PROGRESS_getInstance,
  CourseAssignmentStatus_COMPLETED_getInstance1juqpp2aasyzo as CourseAssignmentStatus_COMPLETED_getInstance,
} from './Shared7Punches-business-domains-training-domain.mjs';
import {
  IListLocalSource39ga4nlfbxuv1 as IListLocalSource,
  ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider,
  SimpleListCacheLocalSource9ig3nhg8ocnr as SimpleListCacheLocalSource,
  SimpleListEndpointCacheStrategy1m0xsspwu4sws as SimpleListEndpointCacheStrategy,
  Companion_instance38at02i5wbrbj as Companion_instance_0,
  UnexpectedApiResponse11rd45rhjxm6r as UnexpectedApiResponse,
} from './Shared7Punches-common-base.mjs';
import {
  Clientssjxb7gh2u6y as Client,
  Companion_getInstance35hsivaslc5e3 as Companion_getInstance_0,
  ApiVersion_JULY_2026_getInstance26s1g5r9ct27x as ApiVersion_JULY_2026_getInstance,
  buildV2Path1ie1ylvss3rsk as buildV2Path,
  mapApiErrorResponse18m737xo6p7hy as mapApiErrorResponse,
  get_sharedJson2ja82jrdlkmvt as get_sharedJson,
} from './Shared7Punches-infrastructure-network.mjs';
import { ICache3bwileb79diof as ICache } from './Shared7Punches-infrastructure-cache.mjs';
import { ILogger102gekz4uf4a8 as ILogger } from './Shared7Punches-infrastructure-logging.mjs';
import {
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldException_init_$Create$1mnsp66c6fnup as UnknownFieldException_init_$Create$,
  LongSerializer_getInstance3iic24guzegu7 as LongSerializer_getInstance,
  StringSerializer_getInstance1k1oz5j50sfik as StringSerializer_getInstance,
  BooleanSerializer_getInstancet3wtk7fl7i4f as BooleanSerializer_getInstance,
  get_nullable197rfua9r7fsz as get_nullable,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  createAnnotatedEnumSerializer20ay4pme9p2h9 as createAnnotatedEnumSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  STRING_getInstance2gbamclnmtzqa as STRING_getInstance,
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
  KSerializerzf77vz1967fq as KSerializer,
  serializer1hwzc6m64v1op as serializer,
  LIST_getInstance3iji3zetpdcxm as LIST_getInstance,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  LocalDateIso8601Serializer_getInstance3ex7tmain73il as LocalDateIso8601Serializer_getInstance,
  Instant3cn81rq2kpflk as Instant,
  Companion_getInstancevs8qhtsjhyer as Companion_getInstance_1,
  Companion_getInstance2irhlaa79e82g as Companion_getInstance_2,
  toInstant2q17i3aluy6ks as toInstant,
} from './Kotlin-DateTime-library-kotlinx-datetime.mjs';
import {
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  url2l6iw5ri21nxb as url,
  headers24pki7ce1busg as headers,
  HttpStatement3zxb33q8lku as HttpStatement,
} from './ktor-ktor-client-ktor-client-core.mjs';
import { Companion_getInstancepumzx9q4106p as Companion_getInstance_3 } from './ktor-ktor-http.mjs';
import {
  JsonElementf07o4p6p57al as JsonElement,
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
} from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from './ktor-ktor-utils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForCompanion(Companion);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiCourseAssignment, 'ApiCourseAssignment', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
initMetadataForCompanion(Companion_0);
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiCourseAssignmentListResponse, 'ApiCourseAssignmentListResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForCompanion(Companion_1);
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiTrainingStep, 'ApiTrainingStep', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
initMetadataForCompanion(Companion_2, VOID, [SerializerFactory]);
initMetadataForClass(ApiTrainingStepStatus, 'ApiTrainingStepStatus', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_7});
initMetadataForLambda(CourseAssignmentRepository$cacheStrategy$slambda, CoroutineImpl, VOID, [1]);
initMetadataForFunctionReference(CourseAssignmentRepository$getRemoteAssignments$ref, VOID, VOID, [0]);
initMetadataForCoroutine($getRemoteAssignmentsCOROUTINE$3, CoroutineImpl);
initMetadataForClass(CourseAssignmentRepository, 'CourseAssignmentRepository', VOID, VOID, [ICourseAssignmentAccessor, ICourseAssignmentMutator], [1, 0]);
initMetadataForClass(TrainingReviewRequestRepository, 'TrainingReviewRequestRepository', VOID, VOID, [ITrainingReviewRequestAccessor]);
initMetadataForClass(TrainingTaskSignOffReviewRepository, 'TrainingTaskSignOffReviewRepository', VOID, VOID, [ITrainingTaskSignOffReviewAccessor]);
initMetadataForObject(SevenDateTimeSerializer, 'SevenDateTimeSerializer', VOID, VOID, [KSerializer]);
initMetadataForCoroutine($listCOROUTINE$4, CoroutineImpl);
initMetadataForInterface(ICourseAssignmentRemoteSource, 'ICourseAssignmentRemoteSource', VOID, VOID, VOID, [0, 1]);
initMetadataForClass(CourseAssignmentRemoteSource, 'CourseAssignmentRemoteSource', VOID, VOID, [ICourseAssignmentRemoteSource], [0, 1]);
initMetadataForInterface(ITrainingReviewRequestRemoteSource, 'ITrainingReviewRequestRemoteSource', VOID, VOID, VOID, [1]);
initMetadataForInterface(ITrainingTaskSignOffReviewRemoteSource, 'ITrainingTaskSignOffReviewRemoteSource', VOID, VOID, VOID, [1]);
initMetadataForClass(TrainingReviewRequestRemoteSource, 'TrainingReviewRequestRemoteSource', VOID, VOID, [ITrainingReviewRequestRemoteSource], [1]);
initMetadataForClass(TrainingTaskSignOffReviewRemoteSource, 'TrainingTaskSignOffReviewRemoteSource', VOID, VOID, [ITrainingTaskSignOffReviewRemoteSource], [1]);
//endregion
function get_trainingModule() {
  _init_properties_TrainingModule_kt__prsg56();
  return trainingModule;
}
var trainingModule;
function trainingModule$lambda($this$module) {
  _init_properties_TrainingModule_kt__prsg56();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = trainingModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(ICourseAssignmentRemoteSource), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp4 = new TypeQualifier(getKClass(CourseAssignment));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = trainingModule$lambda$lambda_0;
  var scopeQualifier_0 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Singleton_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(IListLocalSource), tmp4, definition, kind_0, secondaryTypes_0);
  var factory_0 = new SingleInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_0);
  }
  new KoinDefinition($this$module, factory_0);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_0 = trainingModule$lambda$lambda_1;
  var scopeQualifier_1 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Singleton_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(CourseAssignmentRepository), null, definition_0, kind_1, secondaryTypes_1);
  var factory_1 = new SingleInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_1);
  }
  var tmp = new KoinDefinition($this$module, factory_1);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$13 = [getKClass(ICourseAssignmentAccessor), getKClass(ICourseAssignmentMutator)];
  binds(tmp, tmp$ret$13);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_0 = trainingModule$lambda$lambda_2;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_2 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_2 = Kind_Factory_getInstance();
  var secondaryTypes_2 = emptyList();
  var def_2 = new BeanDefinition(scopeQualifier_2, getKClass(ITrainingReviewRequestRemoteSource), null, tmp2_0, kind_2, secondaryTypes_2);
  var factory_2 = new FactoryInstanceFactory(def_2);
  $this$module.p1c(factory_2);
  new KoinDefinition($this$module, factory_2);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_1 = trainingModule$lambda$lambda_3;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_3 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_3 = Kind_Factory_getInstance();
  var secondaryTypes_3 = emptyList();
  var def_3 = new BeanDefinition(scopeQualifier_3, getKClass(ITrainingReviewRequestAccessor), null, tmp2_1, kind_3, secondaryTypes_3);
  var factory_3 = new FactoryInstanceFactory(def_3);
  $this$module.p1c(factory_3);
  new KoinDefinition($this$module, factory_3);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_2 = trainingModule$lambda$lambda_4;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_4 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_4 = Kind_Factory_getInstance();
  var secondaryTypes_4 = emptyList();
  var def_4 = new BeanDefinition(scopeQualifier_4, getKClass(ITrainingTaskSignOffReviewRemoteSource), null, tmp2_2, kind_4, secondaryTypes_4);
  var factory_4 = new FactoryInstanceFactory(def_4);
  $this$module.p1c(factory_4);
  new KoinDefinition($this$module, factory_4);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_3 = trainingModule$lambda$lambda_5;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_5 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_5 = Kind_Factory_getInstance();
  var secondaryTypes_5 = emptyList();
  var def_5 = new BeanDefinition(scopeQualifier_5, getKClass(ITrainingTaskSignOffReviewAccessor), null, tmp2_3, kind_5, secondaryTypes_5);
  var factory_5 = new FactoryInstanceFactory(def_5);
  $this$module.p1c(factory_5);
  new KoinDefinition($this$module, factory_5);
  return Unit_instance;
}
function trainingModule$lambda$lambda($this$factory, it) {
  _init_properties_TrainingModule_kt__prsg56();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new CourseAssignmentRemoteSource(tmp, tmp$ret$1);
}
function trainingModule$lambda$lambda_0($this$single, it) {
  _init_properties_TrainingModule_kt__prsg56();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleListCacheLocalSource('course_assignments', tmp$ret$0);
}
function trainingModule$lambda$lambda_1($this$single, it) {
  _init_properties_TrainingModule_kt__prsg56();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(ICourseAssignmentRemoteSource), null, null);
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(CourseAssignment));
  var tmp$ret$2 = $this$single.q1d(getKClass(IListLocalSource), qualifier, null);
  return new CourseAssignmentRepository(tmp, tmp$ret$2);
}
function trainingModule$lambda$lambda_2($this$factory, it) {
  _init_properties_TrainingModule_kt__prsg56();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new TrainingReviewRequestRemoteSource(tmp, tmp$ret$1);
}
function trainingModule$lambda$lambda_3($this$factory, it) {
  _init_properties_TrainingModule_kt__prsg56();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(ITrainingReviewRequestRemoteSource), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ILogger), null, null);
  return new TrainingReviewRequestRepository(tmp, tmp$ret$1);
}
function trainingModule$lambda$lambda_4($this$factory, it) {
  _init_properties_TrainingModule_kt__prsg56();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new TrainingTaskSignOffReviewRemoteSource(tmp, tmp$ret$1);
}
function trainingModule$lambda$lambda_5($this$factory, it) {
  _init_properties_TrainingModule_kt__prsg56();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(ITrainingTaskSignOffReviewRemoteSource), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ILogger), null, null);
  return new TrainingTaskSignOffReviewRepository(tmp, tmp$ret$1);
}
var properties_initialized_TrainingModule_kt_x116fs;
function _init_properties_TrainingModule_kt__prsg56() {
  if (!properties_initialized_TrainingModule_kt_x116fs) {
    properties_initialized_TrainingModule_kt_x116fs = true;
    trainingModule = module_0(VOID, trainingModule$lambda);
  }
}
function toDomain(_this__u8e3s4) {
  var tmp = new Course(_this__u8e3s4.z6r_1, _this__u8e3s4.a6s_1, _this__u8e3s4.b6s_1, _this__u8e3s4.c6s_1);
  // Inline function 'kotlin.collections.map' call
  var this_0 = _this__u8e3s4.g6s_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = toDomain_0(item.h6s_1);
    destination.e(tmp$ret$0);
  }
  return new CourseAssignment(_this__u8e3s4.x6r_1, _this__u8e3s4.y6r_1, tmp, _this__u8e3s4.d6s_1, _this__u8e3s4.e6s_1, _this__u8e3s4.f6s_1, destination);
}
function toDomain_0(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.l2_1) {
    case 0:
      tmp = CourseAssignmentStatus_NOT_STARTED_getInstance();
      break;
    case 1:
      tmp = CourseAssignmentStatus_IN_PROGRESS_getInstance();
      break;
    case 2:
      tmp = CourseAssignmentStatus_COMPLETED_getInstance();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function ApiCourseAssignment$Companion$$childSerializers$_anonymous__1oymeg() {
  return new ArrayListSerializer($serializer_getInstance_1());
}
function Companion() {
  Companion_instance_1 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.i6s_1 = [null, null, null, null, null, null, null, null, null, lazy(tmp_0, ApiCourseAssignment$Companion$$childSerializers$_anonymous__1oymeg)];
}
var Companion_instance_1;
function Companion_getInstance_4() {
  if (Companion_instance_1 == null)
    new Companion();
  return Companion_instance_1;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.training.model.ApiCourseAssignment', this, 10);
  tmp0_serialDesc.wy('id', false);
  tmp0_serialDesc.wy('uuid', false);
  tmp0_serialDesc.wy('course_id', false);
  tmp0_serialDesc.wy('course_title', false);
  tmp0_serialDesc.wy('course_description', false);
  tmp0_serialDesc.wy('is_mandatory', false);
  tmp0_serialDesc.wy('started_at', false);
  tmp0_serialDesc.wy('completed_at', false);
  tmp0_serialDesc.wy('due_date', false);
  tmp0_serialDesc.wy('steps', false);
  this.j6s_1 = tmp0_serialDesc;
}
protoOf($serializer).k6s = function (encoder, value) {
  var tmp0_desc = this.j6s_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  var tmp2_cached = Companion_getInstance_4().i6s_1;
  tmp1_output.vs(tmp0_desc, 0, value.x6r_1);
  tmp1_output.zs(tmp0_desc, 1, value.y6r_1);
  tmp1_output.vs(tmp0_desc, 2, value.z6r_1);
  tmp1_output.zs(tmp0_desc, 3, value.a6s_1);
  tmp1_output.zs(tmp0_desc, 4, value.b6s_1);
  tmp1_output.rs(tmp0_desc, 5, value.c6s_1);
  tmp1_output.dt(tmp0_desc, 6, SevenDateTimeSerializer_getInstance(), value.d6s_1);
  tmp1_output.dt(tmp0_desc, 7, SevenDateTimeSerializer_getInstance(), value.e6s_1);
  tmp1_output.dt(tmp0_desc, 8, LocalDateIso8601Serializer_getInstance(), value.f6s_1);
  tmp1_output.bt(tmp0_desc, 9, tmp2_cached[9].t(), value.g6s_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer).yn = function (encoder, value) {
  return this.k6s(encoder, value instanceof ApiCourseAssignment ? value : THROW_CCE());
};
protoOf($serializer).zn = function (decoder) {
  var tmp0_desc = this.j6s_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = null;
  var tmp6_local2 = new Long(0, 0);
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = false;
  var tmp10_local6 = null;
  var tmp11_local7 = null;
  var tmp12_local8 = null;
  var tmp13_local9 = null;
  var tmp14_input = decoder.kr(tmp0_desc);
  var tmp15_cached = Companion_getInstance_4().i6s_1;
  if (tmp14_input.as()) {
    tmp4_local0 = tmp14_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp14_input.ur(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp14_input.qr(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp14_input.ur(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp14_input.ur(tmp0_desc, 4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp14_input.mr(tmp0_desc, 5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp14_input.yr(tmp0_desc, 6, SevenDateTimeSerializer_getInstance(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp14_input.yr(tmp0_desc, 7, SevenDateTimeSerializer_getInstance(), tmp11_local7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp14_input.yr(tmp0_desc, 8, LocalDateIso8601Serializer_getInstance(), tmp12_local8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
    tmp13_local9 = tmp14_input.wr(tmp0_desc, 9, tmp15_cached[9].t(), tmp13_local9);
    tmp3_bitMask0 = tmp3_bitMask0 | 512;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp14_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp14_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp14_input.ur(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp14_input.qr(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp14_input.ur(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp14_input.ur(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp14_input.mr(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp14_input.yr(tmp0_desc, 6, SevenDateTimeSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp14_input.yr(tmp0_desc, 7, SevenDateTimeSerializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp14_input.yr(tmp0_desc, 8, LocalDateIso8601Serializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        case 9:
          tmp13_local9 = tmp14_input.wr(tmp0_desc, 9, tmp15_cached[9].t(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp14_input.lr(tmp0_desc);
  return ApiCourseAssignment_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
};
protoOf($serializer).xn = function () {
  return this.j6s_1;
};
protoOf($serializer).pz = function () {
  var tmp0_cached = Companion_getInstance_4().i6s_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(SevenDateTimeSerializer_getInstance()), get_nullable(SevenDateTimeSerializer_getInstance()), get_nullable(LocalDateIso8601Serializer_getInstance()), tmp0_cached[9].t()];
};
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function ApiCourseAssignment_init_$Init$(seen0, id, uuid, courseId, courseTitle, courseDescription, isMandatory, startedAt, completedAt, dueDate, steps, serializationConstructorMarker, $this) {
  if (!(1023 === (1023 & seen0))) {
    throwMissingFieldException(seen0, 1023, $serializer_getInstance().j6s_1);
  }
  $this.x6r_1 = id;
  $this.y6r_1 = uuid;
  $this.z6r_1 = courseId;
  $this.a6s_1 = courseTitle;
  $this.b6s_1 = courseDescription;
  $this.c6s_1 = isMandatory;
  $this.d6s_1 = startedAt;
  $this.e6s_1 = completedAt;
  $this.f6s_1 = dueDate;
  $this.g6s_1 = steps;
  return $this;
}
function ApiCourseAssignment_init_$Create$(seen0, id, uuid, courseId, courseTitle, courseDescription, isMandatory, startedAt, completedAt, dueDate, steps, serializationConstructorMarker) {
  return ApiCourseAssignment_init_$Init$(seen0, id, uuid, courseId, courseTitle, courseDescription, isMandatory, startedAt, completedAt, dueDate, steps, serializationConstructorMarker, objectCreate(protoOf(ApiCourseAssignment)));
}
function ApiCourseAssignment() {
}
protoOf(ApiCourseAssignment).toString = function () {
  return 'ApiCourseAssignment(id=' + this.x6r_1.toString() + ', uuid=' + this.y6r_1 + ', courseId=' + this.z6r_1.toString() + ', courseTitle=' + this.a6s_1 + ', courseDescription=' + this.b6s_1 + ', isMandatory=' + this.c6s_1 + ', startedAt=' + toString(this.d6s_1) + ', completedAt=' + toString(this.e6s_1) + ', dueDate=' + toString(this.f6s_1) + ', steps=' + toString_0(this.g6s_1) + ')';
};
protoOf(ApiCourseAssignment).hashCode = function () {
  var result = this.x6r_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.y6r_1) | 0;
  result = imul(result, 31) + this.z6r_1.hashCode() | 0;
  result = imul(result, 31) + getStringHashCode(this.a6s_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.b6s_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.c6s_1) | 0;
  result = imul(result, 31) + (this.d6s_1 == null ? 0 : this.d6s_1.hashCode()) | 0;
  result = imul(result, 31) + (this.e6s_1 == null ? 0 : this.e6s_1.hashCode()) | 0;
  result = imul(result, 31) + (this.f6s_1 == null ? 0 : this.f6s_1.hashCode()) | 0;
  result = imul(result, 31) + hashCode(this.g6s_1) | 0;
  return result;
};
protoOf(ApiCourseAssignment).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiCourseAssignment))
    return false;
  var tmp0_other_with_cast = other instanceof ApiCourseAssignment ? other : THROW_CCE();
  if (!this.x6r_1.equals(tmp0_other_with_cast.x6r_1))
    return false;
  if (!(this.y6r_1 === tmp0_other_with_cast.y6r_1))
    return false;
  if (!this.z6r_1.equals(tmp0_other_with_cast.z6r_1))
    return false;
  if (!(this.a6s_1 === tmp0_other_with_cast.a6s_1))
    return false;
  if (!(this.b6s_1 === tmp0_other_with_cast.b6s_1))
    return false;
  if (!(this.c6s_1 === tmp0_other_with_cast.c6s_1))
    return false;
  if (!equals(this.d6s_1, tmp0_other_with_cast.d6s_1))
    return false;
  if (!equals(this.e6s_1, tmp0_other_with_cast.e6s_1))
    return false;
  if (!equals(this.f6s_1, tmp0_other_with_cast.f6s_1))
    return false;
  if (!equals(this.g6s_1, tmp0_other_with_cast.g6s_1))
    return false;
  return true;
};
function ApiCourseAssignmentListResponse$Companion$$childSerializers$_anonymous__sf15ft() {
  return new ArrayListSerializer($serializer_getInstance());
}
function Companion_0() {
  Companion_instance_2 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.l6s_1 = [lazy(tmp_0, ApiCourseAssignmentListResponse$Companion$$childSerializers$_anonymous__sf15ft)];
}
var Companion_instance_2;
function Companion_getInstance_5() {
  if (Companion_instance_2 == null)
    new Companion_0();
  return Companion_instance_2;
}
function $serializer_0() {
  $serializer_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.training.model.ApiCourseAssignmentListResponse', this, 1);
  tmp0_serialDesc.wy('assignments', false);
  this.m6s_1 = tmp0_serialDesc;
}
protoOf($serializer_0).n6s = function (encoder, value) {
  var tmp0_desc = this.m6s_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  var tmp2_cached = Companion_getInstance_5().l6s_1;
  tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0].t(), value.o6s_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_0).yn = function (encoder, value) {
  return this.n6s(encoder, value instanceof ApiCourseAssignmentListResponse ? value : THROW_CCE());
};
protoOf($serializer_0).zn = function (decoder) {
  var tmp0_desc = this.m6s_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.kr(tmp0_desc);
  var tmp6_cached = Companion_getInstance_5().l6s_1;
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.wr(tmp0_desc, 0, tmp6_cached[0].t(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.wr(tmp0_desc, 0, tmp6_cached[0].t(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ApiCourseAssignmentListResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_0).xn = function () {
  return this.m6s_1;
};
protoOf($serializer_0).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_5().l6s_1[0].t()];
};
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 == null)
    new $serializer_0();
  return $serializer_instance_0;
}
function ApiCourseAssignmentListResponse_init_$Init$(seen0, assignments, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_0().m6s_1);
  }
  $this.o6s_1 = assignments;
  return $this;
}
function ApiCourseAssignmentListResponse_init_$Create$(seen0, assignments, serializationConstructorMarker) {
  return ApiCourseAssignmentListResponse_init_$Init$(seen0, assignments, serializationConstructorMarker, objectCreate(protoOf(ApiCourseAssignmentListResponse)));
}
function ApiCourseAssignmentListResponse(assignments) {
  Companion_getInstance_5();
  this.o6s_1 = assignments;
}
protoOf(ApiCourseAssignmentListResponse).toString = function () {
  return 'ApiCourseAssignmentListResponse(assignments=' + toString_0(this.o6s_1) + ')';
};
protoOf(ApiCourseAssignmentListResponse).hashCode = function () {
  return hashCode(this.o6s_1);
};
protoOf(ApiCourseAssignmentListResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiCourseAssignmentListResponse))
    return false;
  var tmp0_other_with_cast = other instanceof ApiCourseAssignmentListResponse ? other : THROW_CCE();
  if (!equals(this.o6s_1, tmp0_other_with_cast.o6s_1))
    return false;
  return true;
};
function ApiTrainingStep$Companion$$childSerializers$_anonymous__vjdcba() {
  return Companion_getInstance_7().v61();
}
function Companion_1() {
  Companion_instance_3 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.q6s_1 = [lazy(tmp_0, ApiTrainingStep$Companion$$childSerializers$_anonymous__vjdcba)];
}
var Companion_instance_3;
function Companion_getInstance_6() {
  if (Companion_instance_3 == null)
    new Companion_1();
  return Companion_instance_3;
}
function $serializer_1() {
  $serializer_instance_1 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.training.model.ApiTrainingStep', this, 1);
  tmp0_serialDesc.wy('status', false);
  this.r6s_1 = tmp0_serialDesc;
}
protoOf($serializer_1).s6s = function (encoder, value) {
  var tmp0_desc = this.r6s_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  var tmp2_cached = Companion_getInstance_6().q6s_1;
  tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0].t(), value.h6s_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_1).yn = function (encoder, value) {
  return this.s6s(encoder, value instanceof ApiTrainingStep ? value : THROW_CCE());
};
protoOf($serializer_1).zn = function (decoder) {
  var tmp0_desc = this.r6s_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.kr(tmp0_desc);
  var tmp6_cached = Companion_getInstance_6().q6s_1;
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.wr(tmp0_desc, 0, tmp6_cached[0].t(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.wr(tmp0_desc, 0, tmp6_cached[0].t(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ApiTrainingStep_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_1).xn = function () {
  return this.r6s_1;
};
protoOf($serializer_1).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_6().q6s_1[0].t()];
};
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 == null)
    new $serializer_1();
  return $serializer_instance_1;
}
function ApiTrainingStep_init_$Init$(seen0, status, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_1().r6s_1);
  }
  $this.h6s_1 = status;
  return $this;
}
function ApiTrainingStep_init_$Create$(seen0, status, serializationConstructorMarker) {
  return ApiTrainingStep_init_$Init$(seen0, status, serializationConstructorMarker, objectCreate(protoOf(ApiTrainingStep)));
}
function ApiTrainingStep() {
}
protoOf(ApiTrainingStep).toString = function () {
  return 'ApiTrainingStep(status=' + this.h6s_1.toString() + ')';
};
protoOf(ApiTrainingStep).hashCode = function () {
  return this.h6s_1.hashCode();
};
protoOf(ApiTrainingStep).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiTrainingStep))
    return false;
  var tmp0_other_with_cast = other instanceof ApiTrainingStep ? other : THROW_CCE();
  if (!this.h6s_1.equals(tmp0_other_with_cast.h6s_1))
    return false;
  return true;
};
function _get_$cachedSerializer__te6jhj($this) {
  return $this.p6s_1.t();
}
function ApiTrainingStepStatus$Companion$_anonymous__9t78hv() {
  var tmp = values();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = ['not_started', 'in_progress', 'completed'];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [null, null, null];
  return createAnnotatedEnumSerializer('com.sevenshifts.shared.data.training.model.ApiTrainingStepStatus', tmp, tmp_0, tmp$ret$5, null);
}
var ApiTrainingStepStatus_NOT_STARTED_instance;
var ApiTrainingStepStatus_IN_PROGRESS_instance;
var ApiTrainingStepStatus_COMPLETED_instance;
function values() {
  return [ApiTrainingStepStatus_NOT_STARTED_getInstance(), ApiTrainingStepStatus_IN_PROGRESS_getInstance(), ApiTrainingStepStatus_COMPLETED_getInstance()];
}
function Companion_2() {
  Companion_instance_4 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.p6s_1 = lazy(tmp_0, ApiTrainingStepStatus$Companion$_anonymous__9t78hv);
}
protoOf(Companion_2).v61 = function () {
  return _get_$cachedSerializer__te6jhj(this);
};
protoOf(Companion_2).a10 = function (typeParamsSerializers) {
  return this.v61();
};
var Companion_instance_4;
function Companion_getInstance_7() {
  ApiTrainingStepStatus_initEntries();
  if (Companion_instance_4 == null)
    new Companion_2();
  return Companion_instance_4;
}
var ApiTrainingStepStatus_entriesInitialized;
function ApiTrainingStepStatus_initEntries() {
  if (ApiTrainingStepStatus_entriesInitialized)
    return Unit_instance;
  ApiTrainingStepStatus_entriesInitialized = true;
  ApiTrainingStepStatus_NOT_STARTED_instance = new ApiTrainingStepStatus('NOT_STARTED', 0);
  ApiTrainingStepStatus_IN_PROGRESS_instance = new ApiTrainingStepStatus('IN_PROGRESS', 1);
  ApiTrainingStepStatus_COMPLETED_instance = new ApiTrainingStepStatus('COMPLETED', 2);
  Companion_getInstance_7();
}
function ApiTrainingStepStatus(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function ApiTrainingStepStatus_NOT_STARTED_getInstance() {
  ApiTrainingStepStatus_initEntries();
  return ApiTrainingStepStatus_NOT_STARTED_instance;
}
function ApiTrainingStepStatus_IN_PROGRESS_getInstance() {
  ApiTrainingStepStatus_initEntries();
  return ApiTrainingStepStatus_IN_PROGRESS_instance;
}
function ApiTrainingStepStatus_COMPLETED_getInstance() {
  ApiTrainingStepStatus_initEntries();
  return ApiTrainingStepStatus_COMPLETED_instance;
}
function getRemoteAssignments($this, $completion) {
  var tmp = new $getRemoteAssignmentsCOROUTINE$3($this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
}
function CourseAssignmentRepository$cacheStrategy$slambda(this$0, resultContinuation) {
  this.k6t_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(CourseAssignmentRepository$cacheStrategy$slambda).m6t = function (it, $completion) {
  var tmp = this.n6t(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(CourseAssignmentRepository$cacheStrategy$slambda).h9 = function (p1, $completion) {
  return this.m6t((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(CourseAssignmentRepository$cacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.k6t_1.p6t_1.m2u(this.l6t_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(CourseAssignmentRepository$cacheStrategy$slambda).n6t = function (it, completion) {
  var i = new CourseAssignmentRepository$cacheStrategy$slambda(this.k6t_1, completion);
  i.l6t_1 = it;
  return i;
};
function CourseAssignmentRepository$cacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new CourseAssignmentRepository$cacheStrategy$slambda(this$0, resultContinuation);
  var l = function (it, $completion) {
    return i.m6t(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function CourseAssignmentRepository$getRemoteAssignments$ref($boundThis) {
  this.r6t_1 = $boundThis;
}
protoOf(CourseAssignmentRepository$getRemoteAssignments$ref).s6t = function ($completion) {
  var tmp = getRemoteAssignments(this.r6t_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    return tmp;
  return tmp;
};
protoOf(CourseAssignmentRepository$getRemoteAssignments$ref).ma = function ($completion) {
  return this.s6t($completion);
};
function CourseAssignmentRepository$getRemoteAssignments$ref_0($boundThis) {
  var i = new CourseAssignmentRepository$getRemoteAssignments$ref($boundThis);
  var l = function ($completion) {
    return i.s6t($completion);
  };
  l.callableName = 'getRemoteAssignments';
  l.$arity = 0;
  return l;
}
function CourseAssignmentRepository$cacheStrategy$lambda(it) {
  return it;
}
function CourseAssignmentRepository$cacheStrategy$lambda_0($this$SimpleListEndpointCacheStrategy) {
  return $this$SimpleListEndpointCacheStrategy.g6r_1;
}
function $getRemoteAssignmentsCOROUTINE$3(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.b6t_1 = _this__u8e3s4;
}
protoOf($getRemoteAssignmentsCOROUTINE$3).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.b6t_1.o6t_1.t6t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          var this_0 = suspendResult.ul_1;
          var tmp_0;
          if (_Result___get_isSuccess__impl__sndoy8(this_0)) {
            var tmp_1 = _Result___get_value__impl__bjfvqg(this_0);
            var this_1 = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
            var _iterator__ex2g4s = this_1.j();
            while (_iterator__ex2g4s.k()) {
              var item = _iterator__ex2g4s.l();
              destination.e(toDomain(item));
            }
            tmp_0 = _Result___init__impl__xyqfz8(destination);
          } else {
            tmp_0 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this_0));
          }

          return new Result(tmp_0);
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function CourseAssignmentRepository(remoteSource, localSource) {
  this.o6t_1 = remoteSource;
  this.p6t_1 = localSource;
  var tmp = this;
  var tmp_0 = this.p6t_1.n18();
  var tmp_1 = CourseAssignmentRepository$cacheStrategy$slambda_0(this, null);
  var tmp_2 = CourseAssignmentRepository$getRemoteAssignments$ref_0(this);
  var tmp_3 = CourseAssignmentRepository$cacheStrategy$lambda;
  tmp.q6t_1 = new SimpleListEndpointCacheStrategy(tmp_0, tmp_1, tmp_2, tmp_3, CourseAssignmentRepository$cacheStrategy$lambda_0);
}
function TrainingReviewRequestRepository(remoteSource, logger) {
  this.u6t_1 = remoteSource;
  this.v6t_1 = logger;
}
function TrainingTaskSignOffReviewRepository(remoteSource, logger) {
  this.w6t_1 = remoteSource;
  this.x6t_1 = logger;
}
function SevenDateTimeSerializer() {
  SevenDateTimeSerializer_instance = this;
  this.y6t_1 = PrimitiveSerialDescriptor('SevenDateTime', STRING_getInstance());
}
protoOf(SevenDateTimeSerializer).xn = function () {
  return this.y6t_1;
};
protoOf(SevenDateTimeSerializer).g2s = function (encoder, value) {
  encoder.os(value.toString());
};
protoOf(SevenDateTimeSerializer).yn = function (encoder, value) {
  return this.g2s(encoder, value instanceof Instant ? value : THROW_CCE());
};
protoOf(SevenDateTimeSerializer).zn = function (decoder) {
  var isoDateTime = replace(decoder.fr(), ' ', 'T');
  return toInstant(Companion_getInstance_1().p2s(isoDateTime), Companion_getInstance_2().b2t_1);
};
var SevenDateTimeSerializer_instance;
function SevenDateTimeSerializer_getInstance() {
  if (SevenDateTimeSerializer_instance == null)
    new SevenDateTimeSerializer();
  return SevenDateTimeSerializer_instance;
}
function CourseAssignmentRemoteSource$list$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function CourseAssignmentRemoteSource$list$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance_0().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function $listCOROUTINE$4(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.h6u_1 = _this__u8e3s4;
}
protoOf($listCOROUTINE$4).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 13;
          this.n8_1 = 1;
          suspendResult = this.h6u_1.c6w_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.i6u_1 = suspendResult;
          var tmp_0 = this;
          tmp_0.j6u_1 = this.h6u_1.b6w_1;
          var tmp_1 = this;
          tmp_1.k6u_1 = 'company/' + this.i6u_1.toString() + '/training_course_assignments/mine';
          var tmp_2 = this;
          tmp_2.l6u_1 = ApiVersion_JULY_2026_getInstance();
          this.m6u_1 = this.j6u_1;
          this.n6u_1 = this.k6u_1;
          this.o6u_1 = this.l6u_1;
          var tmp_3 = this;
          tmp_3.p6u_1 = CourseAssignmentRemoteSource$list$lambda;
          this.o8_1 = 3;
          var tmp_4 = this;
          tmp_4.r6u_1 = Companion_instance;
          var tmp_5 = this;
          tmp_5.s6u_1 = this.m6u_1.f6l_1;
          var tmp_6 = this;
          tmp_6.t6u_1 = buildV2Path(this.m6u_1, this.n6u_1);
          this.u6u_1 = this.s6u_1;
          this.v6u_1 = this.t6u_1;
          var tmp_7 = this;
          tmp_7.w6u_1 = this.u6u_1;
          this.x6u_1 = this.w6u_1;
          var tmp_8 = this;
          tmp_8.y6u_1 = this.x6u_1;
          var tmp_9 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.v6u_1);
          headers(this_0, CourseAssignmentRemoteSource$list$lambda_0(this.o6u_1));
          this_0.z5n(this.p6u_1);
          tmp_9.z6u_1 = this_0;
          this.a6v_1 = this.y6u_1;
          this.b6v_1 = this.z6u_1;
          this.b6v_1.q4r_1 = Companion_getInstance_3().f41_1;
          var tmp_10 = this;
          tmp_10.c6v_1 = this.a6v_1;
          var tmp_11 = this;
          tmp_11.d6v_1 = this.b6v_1;
          this.e6v_1 = this.c6v_1;
          this.f6v_1 = this.d6v_1;
          this.n8_1 = 2;
          suspendResult = (new HttpStatement(this.f6v_1, this.e6v_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.g6v_1 = suspendResult;
          var tmp_12 = this;
          this.r6u_1;
          var value = this.g6v_1;
          tmp_12.q6u_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 13;
          this.n8_1 = 4;
          continue $sm;
        case 3:
          this.o8_1 = 13;
          var tmp_13 = this.q8_1;
          if (tmp_13 instanceof CancellationException) {
            this.h6v_1 = this.q8_1;
            var tmp_14 = this;
            throw this.h6v_1;
          } else {
            var tmp_15 = this.q8_1;
            if (tmp_15 instanceof Error) {
              this.i6v_1 = this.q8_1;
              var tmp_16 = this;
              var exception = this.i6v_1;
              tmp_16.q6u_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 4;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 4:
          this.o8_1 = 13;
          this.j6v_1 = this.q6u_1;
          this.k6v_1 = this.j6v_1;
          this.l6v_1 = Result__exceptionOrNull_impl_p6xea9(this.k6v_1);
          if (this.l6v_1 == null) {
            var tmp_17 = this;
            var tmp_18 = _Result___get_value__impl__bjfvqg(this.k6v_1);
            tmp_17.n6v_1 = (tmp_18 == null ? true : !(tmp_18 == null)) ? tmp_18 : THROW_CCE();
            this.o6v_1 = this.n6v_1;
            var tmp_19 = this;
            tmp_19.p6v_1 = this.o6v_1;
            this.q6v_1 = this.p6v_1;
            this.r6v_1 = this.q6v_1.c4u().z43_1;
            var containsArg = this.r6v_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 9;
              var tmp_20 = this;
              tmp_20.u6v_1 = Companion_instance;
              if (getKClass(ApiCourseAssignmentListResponse).equals(getKClass(Unit))) {
                var tmp_21 = this;
                tmp_21.w6v_1 = this.q6v_1;
                this.x6v_1 = this.w6v_1;
                this.n8_1 = 7;
                var tmp_22 = this.x6v_1.y4u();
                var tmp_23 = getKClass(ApiCourseAssignmentListResponse);
                var tmp_24;
                try {
                  tmp_24 = createKType(getKClass(ApiCourseAssignmentListResponse), arrayOf([]), false);
                } catch ($p) {
                  var tmp_25;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_25 = null;
                  } else {
                    throw $p;
                  }
                  tmp_24 = tmp_25;
                }
                suspendResult = tmp_22.a4u(new TypeInfo(tmp_23, tmp_24), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_26 = this;
                tmp_26.y6v_1 = this.q6v_1;
                this.z6v_1 = this.y6v_1;
                this.n8_1 = 6;
                var tmp_27 = this.z6v_1.y4u();
                var tmp_28 = getKClass(JsonElement);
                var tmp_29;
                try {
                  tmp_29 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_30;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_30 = null;
                  } else {
                    throw $p;
                  }
                  tmp_29 = tmp_30;
                }
                suspendResult = tmp_27.a4u(new TypeInfo(tmp_28, tmp_29), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_31 = this;
              tmp_31.a6w_1 = Companion_instance;
              this.n8_1 = 5;
              suspendResult = mapApiErrorResponse(this.q6v_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_32 = this;
            var it = this.l6v_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_32.m6v_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 12;
            continue $sm;
          }

        case 5:
          var tmp4 = suspendResult;
          var tmp_33 = this;
          this.a6w_1;
          tmp_33.s6v_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 11;
          continue $sm;
        case 6:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_34 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiCourseAssignmentListResponse), arrayOf([]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_35;
            if (tmp2 instanceof JsonObject) {
              tmp_35 = tmp2.c3p('data');
            } else {
              tmp_35 = false;
            }
            if (tmp_35) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_36;
              if (dataValue instanceof JsonObject) {
                tmp_36 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_36 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_36 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_36;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_34.v6v_1 = tmp$ret$0;
          this.n8_1 = 8;
          continue $sm;
        case 7:
          var tmp_37 = this;
          tmp_37.v6v_1 = suspendResult instanceof ApiCourseAssignmentListResponse ? suspendResult : THROW_CCE();
          this.n8_1 = 8;
          continue $sm;
        case 8:
          var tmp1 = this.v6v_1;
          var tmp_38 = this;
          this.u6v_1;
          tmp_38.t6v_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 13;
          this.n8_1 = 10;
          continue $sm;
        case 9:
          this.o8_1 = 13;
          var tmp_39 = this.q8_1;
          if (tmp_39 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_40 = this;
            throw e_0;
          } else {
            var tmp_41 = this.q8_1;
            if (tmp_41 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_42 = this;
              tmp_42.t6v_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 10;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 10:
          this.o8_1 = 13;
          var tmp_43 = this;
          var this_2 = this.t6v_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_44;
          if (exception_1 == null) {
            var tmp_45 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_45 == null ? true : !(tmp_45 == null)) ? tmp_45 : THROW_CCE();
            tmp_44 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_44 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_43.s6v_1 = tmp_44.ul_1;
          this.n8_1 = 11;
          continue $sm;
        case 11:
          this.m6v_1 = new Result(this.s6v_1);
          this.n8_1 = 12;
          continue $sm;
        case 12:
          var this_3 = this.m6v_1.ul_1;
          var tmp_46;
          if (_Result___get_isSuccess__impl__sndoy8(this_3)) {
            var tmp_47 = _Result___get_value__impl__bjfvqg(this_3);
            var value_1 = ((tmp_47 == null ? true : !(tmp_47 == null)) ? tmp_47 : THROW_CCE()).o6s_1;
            tmp_46 = _Result___init__impl__xyqfz8(value_1);
          } else {
            tmp_46 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this_3));
          }

          return new Result(tmp_46);
        case 13:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 13) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function CourseAssignmentRemoteSource(apiClient, sessionDataProvider) {
  this.b6w_1 = apiClient;
  this.c6w_1 = sessionDataProvider;
}
protoOf(CourseAssignmentRemoteSource).t6t = function ($completion) {
  var tmp = new $listCOROUTINE$4(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function ICourseAssignmentRemoteSource() {
}
function ITrainingReviewRequestRemoteSource() {
}
function ITrainingTaskSignOffReviewRemoteSource() {
}
function TrainingReviewRequestRemoteSource(apiClient, sessionDataProvider) {
  this.d6w_1 = apiClient;
  this.e6w_1 = sessionDataProvider;
}
function TrainingTaskSignOffReviewRemoteSource(apiClient, sessionDataProvider) {
  this.f6w_1 = apiClient;
  this.g6w_1 = sessionDataProvider;
}
//region block: post-declaration
protoOf($serializer).qz = typeParametersSerializers;
protoOf($serializer_0).qz = typeParametersSerializers;
protoOf($serializer_1).qz = typeParametersSerializers;
//endregion
//region block: exports
export {
  get_trainingModule as get_trainingModule2zcnhh82r0qhg,
};
//endregion

